import {Tailwind} from '@wandb/weave/components/Tailwind';
import React from 'react';

import {useProjectRateLimitsQuery} from '../../generated/graphql';
import {useAdminModeActive} from '../../util/admin';
import ProjectRateLimitInput from './ProjectRateLimitInput';

type ProjectRateLimitsProps = {
  projectName: string;
  entityName: string;
};

export const ProjectRateLimits = ({
  projectName,
  entityName,
}: ProjectRateLimitsProps) => {
  const isAdmin = useAdminModeActive();
  const rateLimitQuery = useProjectRateLimitsQuery({
    skip: !isAdmin,
    variables: {entityName, projectName},
  });

  if (!isAdmin || rateLimitQuery.loading || rateLimitQuery.data == null) {
    return null;
  }

  const originalRateLimits = rateLimitQuery.data.project?.rateLimits;
  const projectID = rateLimitQuery.data.project?.id ?? '';

  return (
    <Tailwind>
      <div className="flex flex-col">
        <div className="mb-4 flex">
          <span className="flex w-[140px] items-center pr-12 text-sm text-moon-500">
            Filestream (write)
          </span>
          <div className="mx-12 flex gap-x-8">
            <ProjectRateLimitInput
              key={originalRateLimits?.filestreamCount} // to force re-render when the rate limit changes
              projectID={projectID}
              originalLimit={originalRateLimits?.filestreamCount ?? 0}
              limitUnitLabel="count per second"
              limitName="filestreamCount"
              limitTitle="Filestream count"
            />
            <ProjectRateLimitInput
              key={originalRateLimits?.filestreamSize} // to force re-render when the rate limit changes
              projectID={projectID}
              originalLimit={originalRateLimits?.filestreamSize ?? 0}
              limitUnitLabel="total MB per second"
              limitName="filestreamSize"
              limitTitle="Filestream size"
            />
          </div>
        </div>
        <div className="flex">
          <span className="flex w-[140px] items-center pr-12 text-sm text-moon-500">
            SDK GraphQL (project read)
          </span>
          <div className="mx-12 flex">
            <ProjectRateLimitInput
              key={originalRateLimits?.sdkGraphqlQuerySeconds} // to force re-render when the rate limit changes
              projectID={projectID}
              originalLimit={originalRateLimits?.sdkGraphqlQuerySeconds ?? 0}
              limitUnitLabel="DB seconds per second"
              limitName="sdkGraphqlQuerySeconds"
              limitTitle="SDK GraphQL query seconds"
            />
          </div>
        </div>
      </div>
    </Tailwind>
  );
};
